module.exports = __webpack_public_path__ + "img/img2.566628b5.png";